module.exports = __webpack_public_path__ + "img/zhi-i2.80ff1b92.jpg";